// extracted by mini-css-extract-plugin
module.exports = {"powerToggle":"styles_powerToggle__1f-yj"};